/* eslint-disable import/order */
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { getNavigationSidebarProductsSettingResource } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsProductsAdvancedRoadmapsHierarchyRoute } from '@jira/router-routes__legacy-global-settings-products-advanced-roadmaps-hierarchy-routes/src/globalSettingsProductsAdvancedRoadmapsHierarchyRoute.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import type { RouteResources } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const globalSettingsProductsAdvancedRoadmapsHierarchyRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(globalSettingsProductsAdvancedRoadmapsHierarchyRoute, () => ({
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
		},

		resources: getNavigationSidebarProductsSettingResource(),
		entryPoint: () => pageEntryPoint,
	}));
